import { render, staticRenderFns } from "./CellRendererDate.vue?vue&type=template&id=5704cd3e"
import script from "./CellRendererDate.vue?vue&type=script&lang=js"
export * from "./CellRendererDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports